<template>
  <div id="page-periods">
    <h5 class="m-4 page-header"> >> {{ $t('PAGES.SETTINGS.SETTINGS') }}</h5>

    <div ref="page-container" class="page-container">
      <div ref="top-container" class="top-container">

        <div class="left-menu" ref="navigation-drawer">
          <memlist-navigation-drawer
            :items="all_sections.map(s => ({ icon: s.icon, value: s.value, text: s.title }))"
            @clicked="on_drawer_item_click"
          />
        
        </div>

        <!-- fill the rest of the width -->
        <div class="content flex-grow-1 flex-fill">
        
          <BasicCompanySettings
            v-if="selected_section_name === 'public'"
            :company="company"
            :regions="regions"
            :extra_datas="extra_datas"
            @selectRegion1="selectRegion1"
          />

          <ErrorReportSettings
            v-if="selected_section_name === 'errors'"
            :company="company"
          />

          <Links 
            v-if="selected_section_name === 'links'"
            :settings="company.company_settings" />

          
          <!--<Registration
            v-if="selected_section_name === 'registration'"
            :regions="regions"
            :company="company"
            :registration="registration"
            @updateRegistration="updateRegistration"
            @selectRegion="selectRegion2"
          />-->

          <Bank
            v-if="selected_section_name === 'bank'"
            :company="company"
          />

          <MemberProfileSettings 
            :company="company"
            v-if="selected_section_name === 'member_profile'"
          />
          
          <PaymentSettings 
            v-if="selected_section_name === 'payment'"
            :company="company" 
            :settings="company.company_settings" 
          />

          <Fortnox v-if="selected_section_name === 'fortnox'" :company="company" />

          <APIConnection
            v-if="selected_section_name === 'api'"
          />

          <EducationSettings v-if="selected_section_name === 'education'" :settings="company.company_settings" />

          <memlist-card v-if="selected_section_name === 'member_requirements'">
            <Requirements :company="company" />
          </memlist-card>
          
          <ExtraData v-if="selected_section_name === 'extra'" />

          <memlist-card v-if="selected_section_name === 'login'">
            <LoginSettings />
          </memlist-card>
          

          <Domains v-if="selected_section_name === 'domains'" :company="company" />

          <FaithSettings v-if="selected_section_name === 'faith'" :company="company" :settings="company.company_settings" />

          <HiddenSettings v-if="selected_section_name === 'hidden' && isTHS" :settings="company.company_settings" />


        </div>
      </div>
    </div>

  
  </div>
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import APIConnection from '@/view/pages/ml/settings/APIConnection.vue';
import Fortnox from '@/view/pages/ml/settings/Fortnox.vue';
import PaymentSettings from '@/view/pages/ml/settings/PaymentSettings.vue';
//import Pricing from '@/view/pages/ml/settings/Pricing.vue';
import Domains from '@/view/pages/ml/settings/Domains.vue';
import Requirements from '@/view/pages/ml/settings/Requirements.vue';
import EducationSettings from '@/view/pages/ml/settings/EducationSettings.vue';
import FaithSettings from '@/view/pages/ml/settings/FaithSettings.vue';
import Bank from '@/view/pages/ml/settings/Bank.vue';
import Titles from '@/view/pages/ml/settings/Titles.vue';
import Registration from '@/view/pages/ml/settings/Registration.vue';
import BasicCompanySettings from '@/view/pages/ml/settings/BasicCompanySettings.vue';
import ExtraData from '@/view/pages/ml/settings/ExtraData.vue';
import Links from '@/view/pages/ml/settings/Links.vue';
import MemberProfileSettings from '@/view/pages/ml/settings/MemberProfileSettings.vue';
import EmailsTab from '@/view/pages/ml/settings/EmailsTab.vue';
import LoginSettings from '@/view/pages/ml/settings/LoginSettings.vue';
import HiddenSettings from '@/view/pages/ml/settings/HiddenSettings.vue';
import ErrorReportSettings from '@/view/pages/ml/settings/ErrorReportSettings.vue';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';



export default {
  name: 'SettingsPage',
  components: {
    ErrorReportSettings,
    HiddenSettings,
    APIConnection,
    Fortnox,
    PaymentSettings, 
    //Pricing,
    Domains,
    Requirements,
    Bank,
    Titles,
    Registration,
    BasicCompanySettings,
    Links,
    MemberProfileSettings,
    ExtraData,
    EducationSettings,
    FaithSettings,
    EmailsTab,
    LoginSettings,
  },
  computed: {
    all_sections() {
      let base = [
        { title: this.$t('PAGES.SETTINGS.BASIC'), icon: 'mdi-earth', name: 'public', top_only: false, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.LINKS'), icon: 'mdi-link-variant', name: 'links', top_only: false, is_ths: false, },
        //{ title: this.$t('PAGES.SETTINGS.REGISTRATION'), icon: 'mdi-clipboard-list', name: 'registration', top_only: true, is_ths: true, },
        { title: this.$t('PAGES.SETTINGS.BANK'), icon: 'mdi-bank', name: 'bank', top_only: false, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.MEMBER_PROFILE'), icon: 'mdi-account-circle', name: 'member_profile', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.PAYMENT'), icon: 'mdi-credit-card-outline', name: 'payment', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.FORTNOX'), icon: 'mdi-file-document-outline', name: 'fortnox', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.MEMBER_REQUIREMENTS'), icon: 'mdi-account-check-outline', name: 'member_requirements', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.EXTRA_DATA'), icon: 'mdi-database-outline', name: 'extra', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.LOGIN'), icon: 'mdi-login-variant', name: 'login', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.DNS'), icon: 'mdi-dns', name: 'domains', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.ERRORS'), icon: 'mdi-bug-outline', name: 'errors', top_only: true, is_ths: false, },
        { title: this.$t('PAGES.SETTINGS.HIDDEN'), icon: 'mdi-eye-off-outline', name: 'hidden', top_only: true, is_ths: true, },
      ];

      if (this.sid !== this.currentCompanyId) {
        base = base.filter(i => !i.top_only);
      }

      if (!this.isTHS) {
        return base.filter(i => !i.is_ths);
      }

      return base;
    },
    selected_section_name() {
      if (this.selected_item === undefined) {
        return '';
      }

      return this.all_sections[this.selected_item].name;
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'isTHS', 'sid'])
  },
  mixins: [ toasts ],
  async mounted() {


    if (this.$route.query.fortnox === 'success') {
      this.toastr('success', this.$t('COMMON.OK'), 'Fortnox är nu kopplat till denna förening');
      this.$router.replace({
        ...this.$route.currentRoute,
        query: {
          fortnox: undefined
        }
      });
    }
    this.company_id = this.$route.params.id;
    this.extra_datas = await this.fetch_system_extra_data();
    await this.loadData();

  },
  data() {
    return {
      selected_item: 0,
      extra_datas: [],
      


      registration: {},
      
      regions: {},
      regionOptions: [],
      sourceRegions: [],
      cmmuneOptions: [],
      communeOptions1: [],
      communeOptions2: [],
      company_id: null,
      company: {
        origins: '',
        smtp: {
          use_custom: false,
          memlist_prefix: '',
          from: '',
          password: '',
          server: '',
          port: 0,
          security: ''
        },
        settings: {}
      }
    };
  },
  watch: {
    currentCompanyId(newValue, oldValue) {
      this.loadOnValidPeriodAndCompany();
    },
    currentPeriodId(newValue, oldValue) {
      this.loadOnValidPeriodAndCompany();
    }
  },
  methods: {

    async fetch_system_extra_data() {
      const res = await axios.get(`/extra_data/system`);

      if (res.status !== 200) {
        throw 'invalid status';
      }

      return res.data;
    },

    on_drawer_item_click({ index, value, text }) {
      this.selected_item = index;
    },
    loadOnValidPeriodAndCompany() {
      if (this.currentCompanyId && this.currentPeriodId && this.currentPeriodId !== -1) {

        this.isTopCompany = this.sid === this.currentCompanyId;
        this.loadData();
      }
    },
    updateTitleSettings(titles) {
      this.company.settings.titles = titles;

      this.updateSettings(this.company.settings);
    },
    putCompany(data) {
      axios
        .put('/company', data)
        .then(res => {
          if (res.status === 204) {
            this.toastr('success', this.$t('COMMON.OK'), this.$t('PAGES.SETTINGS.UPDATED'));
            this.loadData();
          }
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.SETTINGS.UNABLE_UPDATE'));
        });
    },
    updateRegistration(registration) {
      this.putCompany({ company_id: this.currentCompanyId, registration: registration });
    },
    updateSettings(settings) {
      this.putCompany({ company_id: this.currentCompanyId, settings: settings });
    },
    loadRegions() {
      axios
        .get('https://zip.memlist.se/api/v1/regions_communes')
        .then(res => {
          this.regions = res.data.regions;
          this.regionOptions = [];

          for (var k in this.regions) {
            this.regionOptions.push({ value: k, text: this.regions[k].region });
          }

          this.regionOptions.sort(function(a, b) {
            if (a.text < b.text) {
              return -1;
            }
            if (a.text > b.text) {
              return 1;
            }
            return 0;
          });
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta regioner');
        });
    },
    selectRegion1(region_code) {
      this.loadCommunes(region_code, 1);
    },
    selectRegion2(region_codes) {
      this.communeOptions2 = [];

      for (var i = 0; i < region_codes.length; ++i) {
        var comm = this.getCommunes(region_codes[i].code);

        for (var c = 0; c < comm.length; ++c) {
          this.communeOptions2.push({ code: comm[c].value, text: comm[c].text });
        }
      }
    },
    getCommunes(region_code) {
      var comm = [];

      var communes = this.regions[region_code].communes;

      for (var k in communes) {
        comm.push({ value: k, text: communes[k] });
      }

      comm.sort(function(a, b) {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }
        return 0;
      });

      return comm;
    },
    loadCommunes(selectedRegion, option) {

      this.communeOptions = [];

      var communes = this.regions[selectedRegion].communes;

      for (var k in communes) {
        this.communeOptions.push({ value: k, text: communes[k] });
      }

      this.communeOptions.sort(function(a, b) {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }
        return 0;
      });

      if (option == 1) {
        this.communeOptions1 = this.communeOptions;
      } else {
        this.communeOptions2 = this.communeOptions;
      }
    },
    loadExtraData() {
      axios
        .get(`/extra_data?company_id=${this.currentCompanyId}`)
        .then(res => {
          if (res.status === 200) {
            this.extras = res.data;
          }
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta extradata');
        });
    },
    loadData() {
      this.loadRegions();
      let id = this.currentCompanyId;
      if (this.company_id !== '' && this.company_id !== null && this.company_id !== undefined) {
        id = this.company_id;
      }
      axios
        .get(`/company/admin?company_id=${id}`)
        .then(res => {
          if (res.status === 200) {
            this.company = res.data;
            this.registration = { ...this.company.registration };
            this.loadExtraData();
          }
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta föreningsinställningar');
        });
    },
    
  }
};
</script>
<style scoped>
.selected-item-active {
  border-radius: 4px;
  background: #f4fcff;
  color: black;
}

.fill-rest {
  flex: 1 1 auto;
}

.page-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}

.top-container {
  display: flex;
}

.content {
  flex-grow: 1;
  margin-top: 0px !important;
  padding-top: 0px !important;
  margin-left: 8px !important;
}


.drawer-header {
  margin-bottom: -13px !important;
}

.drawer {
  border-right: 1px solid #dddddd !important;
}

.fixed-font {
  font-size: 0.95rem !important;
  font-weight: 500;
  line-height: 1rem;
}


</style>